import React from 'react';
import { Button, Text } from '@ui';
import { formatConversationDate } from '../../../../../../utils/dateUtils';
import { SUPPORT_COPY } from '../../../../constants/support';
import './PastSupportChatBarStyles.scss';
const BASE_CLASS = 'ai-past-chat-bar';
/**
 * Shown above the composer when a customer opens a PAST live chat from the Support chats list. The
 * conversation is read-only until they choose: "Continue this chat" asks the server to bring the
 * chat back to the queue (same Zendesk ticket, or a linked follow-up when that ticket was closed);
 * "Back to IPA" leaves the view and gives the composer back to IPA. Nothing is sent to support
 * until the customer clicks Continue, and the widget never opens a window to do it.
 */
export function PastSupportChatBar({ endedAt = null, canContinue, unavailableNote = null, isWorking = false, onContinue, onBack }) {
    return (
    // A labelled region, not a live region: it holds two buttons. Only the TEXT is announced.
    React.createElement("section", { className: BASE_CLASS, "aria-label": SUPPORT_COPY.PAST_CHAT_BAR_TITLE },
        React.createElement("i", { className: `${BASE_CLASS}__icon fa-light fa-clock-rotate-left`, "aria-hidden": "true" }),
        React.createElement("div", { className: `${BASE_CLASS}__text`, role: "status" },
            React.createElement(Text, { variant: "x-small" }, SUPPORT_COPY.PAST_CHAT_BAR_TITLE),
            React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__detail` }, SUPPORT_COPY.PAST_CHAT_BAR_ENDED(endedAt ? formatConversationDate(endedAt) : '')),
            unavailableNote && (React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__detail` }, unavailableNote))),
        React.createElement("div", { className: `${BASE_CLASS}__actions` },
            React.createElement(Button, { variant: "primary", disabled: !canContinue || isWorking, onClick: onContinue }, SUPPORT_COPY.PAST_CHAT_CONTINUE),
            React.createElement(Button, { disabled: isWorking, onClick: onBack }, SUPPORT_COPY.PAST_CHAT_BACK))));
}
